export const appDirectoryContent = {
    "app-directory": {
      title: "What is App Directory?",
      content: `
      <p>
      The App Directory is your central place for configuring, integrating, and managing third-party applications. Once integrated, these apps act as channels where you can deploy and run your AI Agents.
      </p>

        <image-component src="https://edge-a.anydone.com/treeleaf/37acc6a1-51d9-48a2-bae0-90559e21c062.png" alt="Best-ai-adoption-platform-app-directory"></image-component>

      <p>
        After creating an AI Agent, you can select the created or integrated apps in the App Directory, define an event trigger, and let your custom AI Agent automate the workflow on your selected channel . Notably, you can also create and manage fully customizable anydone’s own ChatPlugin app from here, which allows you to run AI Agents tailored to your specific use cases.
        </p>
      `
    },
    "how-to-create-live-capture":{
        title:"Live Capture",
        content:`
        <p>How to create a Live Capture App in Anydone?</p>

        <ul class="steps-list">
            <li>Log in to your anydone dashboard.</li>
            <li>Click on the app directory icon on the left side.</li>
            <li>Select "Live Capture."</li>
            <li>Enter a name for the app.</li>
            <li>Customize the Live Capture app according to your preferences.</li>
            <li>Click the "Create" button.</li>
        </ul>
        `
    },
    "how-to-create-anydone-app":{
        title:"How to Create Anydone App?",
        content:`
        <p>You can create an app, deploy your AI Agents and automate workflows directly within your anydone workspace. This integration enables you to automate processes across your teams, customers, vendors, suppliers, and more. </p>
        <p>You can select apps, define event triggers, and execute your AI Agent across anydone components such as CoSpace, and project folders like Tickets, Sprints, Forms, and CRM folders.</p>

        <h3 class="headingThree underline-text">Creating an Anydone App (CoSpace) in App Directory</h3>
        <ul class="steps-list">
            <li>Log in to <strong>Anydone</strong></li>
            <li>Click on the <strong>App Directory</strong> icon from the left sidebar</li>
            <li>From the options, select <strong>Anydone</strong></li>
            <li>Click on the + button in the right left-hand side</li>
            <li>Enter a <strong>name</strong> for the app</li>
            <li>From the <strong>Type</strong> dropdown, select <strong>CoSpace</strong></li>
            <li>Now, select your preferred <strong>CoSpace</strong></li>
            <li>Finally, click the <strong>create</strong> button</li>
        </ul>
        <video-component src="https://edge-a.anydone.com/treeleaf/8dcb5e53-4762-47a4-ab01-d8068121cb7c.mp4"></video-component>

        <h3 class="headingThree underline-text">Creating an Anydone App (Ticket / Sprint folder) in App Directory</h3>
        <ul class="steps-list">
            <li>Log in to <strong>Anydone</strong></li>
            <li>Click on the <strong>App Directory</strong> icon from the left sidebar</li>
            <li>From the options, select <strong>Anydone</strong></li>
            <li>Click on the + button in the right left-hand side</li>
            <li>Enter a <strong>name</strong> for the app</li>
            <li>From the <strong>Type</strong> dropdown, select <strong>Ticket</strong></li>
            <li>Select the <strong>Project</strong></li>
            <li>Now, select your preferred your preferred task folder <strong>Ticket /Sprint folder</strong></li>
            <li>Finally, click the <strong>create</strong> button</li>
        </ul>
        <video-component src="https://edge-a.anydone.com/treeleaf/ada6ab7b-5b43-46be-94ff-f18c5f0c4601.mp4"></video-component>

        <h3 class="headingThree underline-text">Creating an Anydone App (Form folder) in App Directory</h3>
        <ul class="steps-list">
            <li>Log in to <strong>Anydone</strong></li>
            <li>Click on the <strong>App Directory</strong> icon from the left sidebar</li>
            <li>From the options, select <strong>Anydone</strong></li>
            <li>Click on the + button in the right left-hand side</li>
            <li>Enter a <strong>name</strong> for the app</li>
            <li>From the <strong>Type</strong> dropdown, select <strong>Form</strong></li>
            <li>Select the <strong>Project</strong></li>
            <li>Now, select your preferred your preferred task folder <strong>Form folder</strong></li>
            <li>Finally, click the <strong>create</strong> button</li>
        </ul>
        <video-component src="https://edge-a.anydone.com/treeleaf/8a64a480-648b-4310-a353-05a214ec2fb9.mp4"></video-component>

         <h3 class="headingThree underline-text">Creating an Anydone App (CRM) in App Directory</h3>
        <ul class="steps-list">
            <li>Log in to <strong>Anydone</strong></li>
            <li>Click on the <strong>App Directory</strong> icon from the left sidebar</li>
            <li>From the options, select <strong>Anydone</strong></li>
            <li>Click on the + button in the right left-hand side</li>
            <li>Enter a <strong>name</strong> for the app</li>
            <li>From the <strong>Type</strong> dropdown, select <strong>CRM</strong></li>
            <li>Select the <strong>Project</strong></li>
            <li>Now, select your preferred your preferred task folder <strong>CRM folder</strong></li>
            <li>Finally, click the <strong>create</strong> button</li>
        </ul>   
        <video-component src="https://edge-a.anydone.com/treeleaf/5da26703-66b7-4023-bbc0-fef91f944138.mp4"></video-component>
        `
    },
    "aichat":{
        title:"What is a AIChat? | Anydone",
        content:`
        <p>
        Anydone offers a powerful way for users to create a fully customizable communication tool that allows visitors to start interacting with your platform — directly from your website.
        </p>

        <p>
        Once deployed, our chatplugin stays visible on your website page, ready for visitors to engage whenever they need support or have questions.
        </p>

        <p>
        You have full control to customize the chatplugin. You can change how it looks and behaves — including the icon, colors, position, size, and even the greeting message to match your brand identity and website layout.
        </p>

        <p>
        When a visitor clicks on the chat launcher, your configured communication flow begins — connecting them to AI agents, support teams, or specific departments based on your predefined settings.
        </p>

        <p>
        It’s simple to set up, fully responsive across devices, and works seamlessly. This feature ensures your business stays available, approachable, and responsive at every step of the customer journey.
        </p>

        <h3 class="headingThree">Creating a AIChat</h3>
        <ul class="steps-list">
            <li>Log in to <strong>anydone</strong></li>
            <li>Click on the <strong>App Directory</strong> icon from the left sidebar</li>
            <li>From the options, select <strong>Anydone</strong></li>
            <li>Click on the + button in the right left-hand side</li>
            <li>Enter a name for the <strong>Chat Plugin</strong></li>
            <li>Finally, click the <strong>Create</strong> button</li>
        </ul>

        <video-component src="https://edge-a.anydone.com/treeleaf/3810f9ff-2624-4f2c-9f79-845e0685d5a0.mp4"></video-component>

        <h2 class="headingTwo">Overview of the AIChat customization interface.</h2>
        <p>
        The interface is divided into four main sections, each designed to help you tailor AIChat according to your specific requirements:
        </p>

        <p>
        Before you start to customize AIchat, here are the customization overview:
        </p>

        <h3>Customization overview of AIchat</h3>
        <p>You can easily tailor your AIChat to match your brand, interface needs, and data preferences. There are five main areas where you can customize your AIChat experience:</p>
        
        <ol type="1">
            <li>Tabs <br>
            <p>Customize the interface layout of your AIChat. By default, you'll find tabs like Home and Message, but you can add new tabs, rename existing ones, or remove those you don't need. This helps you structure conversations based on your use case.</p>
            </li>

            <li>Branding and Properties <br>
            Control the visual identity and key behavior of your AIChat.
                <ul class="no-listing">
                    <li><span class="underline-text">Language:</span> Set your preferred language for AIChat interactions.</li>
                    <li><span class="underline-text">Launcher:</span> Customize the launcher icon for your brand.</li>
                    <li><span class="underline-text">Authentication:</span> Add user authentication for secure CRM interaction.</li>
                    <li><span class="underline-text">Message Pane:</span> Create or update the welcome message shown to users.</li>
                </ul>
            </li>

            <li>UI Components <br>
            Define the layout and functionality of the chat window. You can add new UI elements or modify existing ones to meet your needs. Components can also be grouped logically to organize the interface and streamline user interaction.
            </li>

            <li>Data Attributes <br>
            Choose what information you'd like to collect during AIChat interactions.Define data fields to capture user inputs, preferences, or any custom attributes required for personalized experiences or CRM mapping.
            </li>

            <li>Settings <br>
           Manage general settings like the AIChat's name, domain access, and branding. You can also remove default branding text and configure domains where your AIChat is permitted to run.
            </li>
        </ol>

        <h3 class="headingThree">Customizable Components</h3>
        <p>Then it's important to understand the custom components you can add to each section of your AIChat interface. </p>

        <ul class="no-listing">
            <li><i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Link:</span> Add a clickable hyperlink with a custom title. You can personalize the font color, font size, and text alignment to match your brand’s style.</li>
            <li><i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Video:</span> Embed a video by simply adding the video URL. You can also include a custom title and description to provide more context to your users.</li>
            <li><i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Button:</span> There are two button types you can create, each offering full customization of font size, text color, and background color.
                <ul>
                    <li><span class="underline-text">Conversation Button:</span> Add a label for the button. When clicked, it triggers a conversation window.</li>
                    <li><span class="underline-text">Open Link Button:</span> Provide a URL and button text. When clicked, it redirects users to the specified link.</li>
                </ul>
            </li>
            <li><i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Text:</span> Add static text to provide information or context. Customize its font size, color, and alignment to fit your design.</li>
            <li><i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Image:</span> Upload images directly and adjust their width and height as needed to seamlessly fit into the chat interface.</li>
            <li><i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Conversation Thread:</span> This special type of button opens the conversational window instantly when clicked, directing users straight into interaction.</li>
            <li><i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Line Break :</span> Use this to insert a simple space or break between two elements. It helps organize content visually without adding additional components.</li>
            <li><i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Horizontal Line :</span> Insert a visual divider across the width of the interface. This helps separate different sections or elements clearly and adds to a cleaner layout.</li>
        </ul>

        <h3 class="headingThree">Customizing Tabs in AIChat</h3>
        <p>AIChat allows you to customize its interface by editing the default tabs like Home and Message or by adding new Tabs and customizing it manually. </p>
        <p>Here's how each section works:</p>

        <h3 class="headingThree">Home</h3>
        <p>In the Home section, you can customize two sections, these two sections are the default section, and also you can add a new section and customize it manually. </p>

        <ul>
            <li><span class="underline-text">Header Customization</span> <br>
            Once you click the settings icon, you’ll see the customization panel. Under the Header section, you can:
                <ul class="no-listing">
                    <li><i class="fa-solid fa-arrow-right-long"></i> Adjust the text alignment and background color.</li>
                    <li><i class="fa-solid fa-arrow-right-long"></i> Upload or delete the header image, and set its width and height.</li>
                    <li><i class="fa-solid fa-arrow-right-long"></i> Change the default text, including its color, size, and alignment.</li>
                    <li><i class="fa-solid fa-arrow-right-long"></i> Add new components by clicking the Add dropdown and selecting from available components.</li>
                </ul>
            </li>

            <li><span class="underline-text">Body Customization</span> <br>
            In the Body tab, you can
                <ul class="no-listing">
                    <li><i class="fa-solid fa-arrow-right-long"></i> Customize default buttons—make them static or link them.</li>
                    <li><i class="fa-solid fa-arrow-right-long"></i> Change button text, color, font, and alignment.</li>
                    <li><i class="fa-solid fa-arrow-right-long"></i> Like the Header, you can also add new components using the Add dropdown.</li>
                </ul>
            </li>

            <li><span class="underline-text">Adding or Removing Tabs</span> <br>
            The Header and Body tabs are included by default, but you can delete them or modify them as needed. You can also add a Footer tab:
                <ul class="no-listing">
                    <li><i class="fa-solid fa-arrow-right-long"></i> After selecting Footer, use the Add dropdown to include components relevant to that section.</li>
                </ul>
            </li>
        </ul>

        <p class="underline-text">Note:</p> <br>
        Don’t forget to save your changes to ensure your customizations are applied.

        <h3 class="headingThree">Message</h3>
        <p>In the Message section, you can customize two sections, these two sections are the default section, and also you can add a new section and customize it manually.</p>

        <ul>
            <li> <span class="underline-text">Header Customization</span> <br>
            Under the Message tab settings, the Header section allows you to:
                <ul class="no-listing">
                    <li><i class="fa-solid fa-arrow-right-long"></i> Change the alignment and background color of the header text.</li>
                    <li><i class="fa-solid fa-arrow-right-long"></i> Upload or remove a header image, and adjust its width and height.</li>
                    <li><i class="fa-solid fa-arrow-right-long"></i> Edit the default header text (change the color, size, and alignment).</li>
                    <li><i class="fa-solid fa-arrow-right-long"></i> Add new components using the Add dropdown to enhance the header area.</li>
                </ul>
            </li>

             <li> <span class="underline-text">Body Customization</span> <br>
            In the Body section, you can:
                <ul class="no-listing">
                    <li><i class="fa-solid fa-arrow-right-long"></i> Edit the default message layout or buttons (make buttons static or attach links).</li>
                    <li><i class="fa-solid fa-arrow-right-long"></i> Customize text, button color, font, and alignment.</li>
                    <li><i class="fa-solid fa-arrow-right-long"></i> Use the Add dropdown to insert components tailored to your chat interaction flow.</li>
                </ul>
            </li>

            <li>
             <span class="underline-text">Body Customization</span> <br>
             You can remove the Message tab entirely, customize it manually, or add new tabs (like Footer) to extend the interface: <br>
             To add the Footer, click Add and select the components you'd like to display.
            </li>
        </ul>
        <p>Reminder: <br>
        Always click "Save" after making changes to apply your updates.</p>

        <h3 class="headingThree">Customizing UI Components</h3>
        <p>The UI Components section allows you to manage the individual building blocks of your AIChat interface. Whether you want to add new interactive elements or organize them for clarity, this section gives you full control over the visual and functional layout of your chat.</p>

        <p>Components <br>
        In this area, you can create new UI components or manage existing ones. Components include buttons, input fields, quick replies, links, and more—each designed to enhance how users interact with your AIChat.
        </p>

        <p>For each component, you can:<p>
        <ul class="no-listing">
            <li><i class="fa-solid fa-arrow-right-long"></i> Add new elements with custom labels, colors, icons, and behavior.</li>
            <li><i class="fa-solid fa-arrow-right-long"></i> Edit existing components to update their appearance or function.</li>
            <li><i class="fa-solid fa-arrow-right-long"></i> Delete components that are no longer needed to keep your interface clean.</li>
        </ul>

        <p>These components can be used across different sections (like Header, Body, or Footer) within your AIChat tabs. They help create a tailored and engaging user experience.</p>

        <p><span class="underline-text">Groups</span>
        Groups let you organize multiple components under one category or layout block. This is especially useful when your AIChat includes many elements and you want to keep things structured.
        </p>
        <p>With Groups, you can:</p>
        <ul class="no-listing">
            <li><i class="fa-solid fa-arrow-right-long"></i> Create logical clusters of components for easier management.</li>
            <li><i class="fa-solid fa-arrow-right-long"></i> Reorder components within a group to match your desired flow.</li>
            <li><i class="fa-solid fa-arrow-right-long"></i> Apply shared styles or settings across all components in the group.</li>
        </ul>
        <p>Always click "Save" after making changes to apply your updates.</p>

        <h3>Tips:</h3>
        <p>After creating a UI Component, make sure to enable "UI Component" while building your AI Agent. Only then will the component appear in your AIChat interface.</p>

        <h3>Customization data attribute and Settings</h3>
        <p> <span class="underline-text">Data Attribute</span> <br>
        Data Attributes let you define what user information should be captured when someone interacts with your AIChat. You can set custom fields such as name, email, phone number, or any specific input relevant to your business. This helps personalize conversations, improve lead quality, and integrate captured data into your CRM or workflow.
        </p>
        <p>
         <span class="underline-text">Settings</span> <br>
         The Settings section allows you to fine-tune the basic properties of your AIChat. You can rename your chat instance, remove default branding text, and specify allowed domains where the AIChat will be active. These controls ensure your AIChat aligns with your brand identity and is accessible only in the environments you authorize.
        </p>
        `
    },
    "how-to-integrate-mail-service":{
        title:"How to integrate Gmail in anydone?",
        content:`
        <p>Integrate your Gmail account with anydone using the SMTP configuration method. Follow these steps to ensure smooth email functionality from within the anydone platform.</p>
        <p>Here are the required fields that you must filled: <br>
        <span class="underline-text">Name:</span> Enter your full name or the name you’d like to display as the sender when emails are sent from anydone.</p>
        <p><span class="underline-text">Email Provider:</span> Select Gmail from the list of available email providers. This allows anydone to automatically configure Gmail settings.</p>
        <p><span class="underline-text">Email Address:</span> Enter your full Gmail address (e.g., yourname@gmail.com). This is the email address that will send and receive messages through anydone.</p>
        <p><span class="underline-text">App Password:</span> Since Gmail no longer supports basic authentication for third-party apps, you must generate an App Password. Make sure your email address has configured 2-Step verification, then generated the Password you are required to add here.</p>
        <p>SMTP Configuration <br>
        <span class="underline-text">Secure Connection:</span> Choose between TLS or SSL for encryption.</p>

        <ul class="no-listing">
            <li><i class="fa-solid fa-arrow-right-long"></i> Use TLS if you're using port 587.</li>
            <li><i class="fa-solid fa-arrow-right-long"></i> Use SSL if you're using port 465.</li>
        </ul>

        <p>SMTP Host Name: Add,  <strong>smtp.gmail.com</strong></p>

        <p>
        <span class="underline-text">SMTP Port: </span>
        </p>
        <ul class="no-listing">
            <li><i class="fa-solid fa-arrow-right-long"></i> Use 587 for TLS </li>
            <li><i class="fa-solid fa-arrow-right-long"></i> Use 465 for SSL</li>
        </ul>
        <p>Make sure the port matches the secure connection method you selected.</p>
        <p>Once done, your Gmail account should now be integrated successfully, allowing you to send emails directly from the platform.</p>

        <h3 class="headingThree">How to integrate Outlook in anydone?</h3>
        <ul class="steps-list">
            <li>Log in to your anydone account.</li>
            <li>Click on the App Integration icon from the left sidebar.</li>
            <li>Click the + button located in the top-right corner.</li>
            <li>Give a name for the app.</li>
            <li>Under Email Provider, click on the dropdown icon.</li>
            <li>Select Microsoft Outlook from the list of options.</li>
            <li>Click on the Next button.</li>
            <li>Copy the code provided.</li>
            <li>Click on the Login with Microsoft button.</li>
        </ul>
        <p>
        Once you click the button, a new interface will appear. Follow these steps:</p>
        <ul class="steps-list">
            <li>Paste the code you copied earlier.</li>
            <li>Click on the Next button.</li>
            <li>Enter your Outlook email address.</li>
            <li>Click on Continue.</li>
            <li>Enter your Outlook password.</li>
            <li>Click on the Accept button.</li>
        </ul>

        <h2 class="headingTwo">How to integrate AWS SES in anydone?</h2>
        <p>To connect your AWS SES (Simple Email Service) account with anydone for email communication , follow the two main steps below:</p>

        <h3 class="headingThree">Step 1: Generate Your AWS SES API Credentials</h3>
        <p>Before integrating AWS SES with anydone, you need to create an access key and secret key from the AWS Console.</p>
        <ul class="steps-list">
            <li>Go to <a href="https://aws.amazon.com/console" target="_blank">https://aws.amazon.com/console</a> and log in.</li>
            <li>Navigate to the <strong>IAM service</strong> from the AWS dashboard.</li>
            <li>Click on Users and then select <strong>Create User.</strong></li>
            <li>Enter a <strong>username</strong> and click <strong>Next.</strong></li>
            <li>Create a <strong>User Group</strong> and attach the following permission policies:
                <ul>
                <li>AmazonSESReadOnlyAccess</li>
                <li>AmazonSESFullAccess</li>
                </ul>
            </li>
            <li>Continue through the <strong>setup</strong> and click <strong>Create User.</strong></li>
            <li>After the user is created, click <strong>Create access key.</strong></li>
            <li>Choose <strong>Application running outside AWS</strong> as the use case (recommended).</li>
            <li>Click <strong>Next</strong>, then click <strong>Create access key.</strong></li>
            <li>Now, copy the <strong>Access key and Secret key.</strong></li>
        </ul>
        <p>Once you copied these keys, then follow these steps: </p>

        <h3 class="headingThree">Step 2: Integrate AWS SES with anydone</h3>
        <ul class="steps-list">
            <li>Log in to your anydone account.</li>
            <li>Click on the App Integration icon from the left sidebar.</li>
            <li>Click the + button located in the top-right corner.</li>
            <li>Give a name for the app.</li>
            <li>Under Email Provider, select AWS SES from the dropdown.</li>
            <li>Paste the Access key you copied earlier in the API Key field.</li>
            <li>Paste the Secret key in the API Secret field.</li>
            <li>Select the appropriate AWS Region where your SES is hosted (e.g., <code>us-east-1</code>).</li>
            <li>Click on Next to complete the integration.</li>
        </ul>

        <h2 class="headingTwo">How to integrate SMTP in anydone?</h2>
        <p>To send emails through your preferred email service provider using SMTP, follow these 3 steps below to configure it within anydone:</p>

        <h3 class="headingThree">Step 1: Access the SMTP Integration Settings</h3>
        <ul class="steps-list">
            <li>Log in to your <strong>anydone</strong> account.</li>
            <li>Click on the <strong>App Integration</strong> icon from the left sidebar.</li>
            <li>Click the + button in the top-right corner.</li>
            <li>Enter a name for your integration (e.g., "Gmail SMTP", "Zoho Mail", etc.).</li>
            <li>Under <strong>Email Provider</strong>, select <strong>SMTP</strong> from the dropdown list.</li>
        </ul>

        <h3 class="headingThree">Step 2: Enter Your SMTP Credentials</h3>
        <ol class="steps-list">
        <li>In the Email Address field, enter the full email address provided by your email service provider (e.g., yourname@domain.com).</li>
        <li>In the App Password field, enter the app-specific password generated from your email service (for Gmail and some others, this is required instead of your account password).</li>
        </ol>
        <p>Tips: <br>
        Do not use your main email account password. Use an app password or SMTP credentials provided by your email provider.
        </p>

        <h3 class="headingThree">Step 3: Configure SMTP Server Settings</h3>
        <ol class="steps-list">
        <li>Under Secure Connection, choose the encryption type based on your email provider: <br>
        For example:<br>
            <ul>
                <li>Use SSL for services like Gmail (smtp.gmail.com on port 465).</li>
                <li>Use TLS for services like Outlook (smtp.office365.com on port 587).</li>
            </ul>
        </li>
        <li>Under SMTP Host Name, enter the outgoing mail server address provided by your email provider.<br>
        For example:<br>
            <ul>
                <li>Gmail: smtp.gmail.com</li>
                <li>Outlook: smtp.office365.com</li>
                <li>Zoho: smtp.zoho.com</li>
            </ul>
        </li>
        <li>Under SMTP Port, enter the port number based on your encryption choice:<br>
        For example:<br>
            <ul>
                <li>SSL → Port 465</li>
                <li>TLS → Port 587</li>
            </ul>
        </li>
        <li>Under SMTP Authentication, choose True to enable authentication (this is typically required for most providers).</li>
        <li>Optionally, you can enable or disable Receive Mail based on whether you want anydone to handle incoming emails for this account.</li>
        </ol>

        <p>Once you’ve entered all the required information, click Next to save and activate your SMTP configuration.</p>
        `
    },
    "how-to-integrate-slack":{
        title:"How to integrate Slack?",
        content:`
        <p>Go to <a href="https://api.slack.com/" target="_blank">api.slack.com</a> & follow the steps to generate Signing Secret & User Token then copy and paste them here respectively:</p>
        <ol class="steps-list">
            <li>Create an App &gt;&gt; From Scratch.</li>
            <li>Give the app a name and select a workspace.</li>
            <li>Click on Create App &gt;&gt; Go to Basic Information &gt;&gt; Copy the Signing Secret.</li>
            <li>Now go back to the anydone dashboard &gt;&gt; <strong>App Directory</strong> &gt;&gt; Slack, and paste the Signing Secret in the placeholder.</li>
            <li><strong>Continue the steps for user token:</strong> Click OAuth &amp; Permissions &gt;&gt; Install to Workspace.</li>
            <li>Select channels &gt;&gt; Click Allow.</li>
            <li>Add an OAuth Scope (select your preferred option).</li>
            <li>Click on "Reinstall your app" &gt;&gt; Select a channel.</li>
            <li>Copy the User OAuth Token &gt;&gt; Paste the User OAuth Token in the <strong>User Token field.</strong></li>
        </ol>
        `
    },
    "how-to-create-a-live-capture-app":{
        title:"How to Create a Live Capture App?",
        content:`
        <ul class="steps-list">
            <li>Log in to your <strong>anydone</strong> dashboard.</li>
            <li>Click on the <strong>App Directory</strong> icon on the left side.</li>
            <li>Select "<strong>Live Capture</strong>."</li>
            <li>Enter a <strong>name</strong> for the app.</li>
            <li>Customize the <strong>Live Capture</strong> app according to your preferences.</li>
            <li>Click the "<strong>Create</strong>" button.</li>
        </ul>
        <p><strong class="underline-text">Customizing Live Capture App</strong><br>
        Watch the video to customize your live capture app according to your needs.
        </p>

        <p><strong class="underline-text">Tips:</strong><br>
        It's not necessary to create a Live Capture app with all three options (image, video, audio). You can choose one, two, or all of them, depending on what you want to capture.
        </p>
        `
    },
    "how-to-integrate-messenger":{
        title:"How to Integrate Messenger?",
        content:`
            <ol class="steps-list">
                <li>Login to your <strong>Meta developers</strong> account.</li>
                <li>Navigate to <strong>Apps > All Apps,</strong> click on the <strong>Create App</strong> button.</li>
                <li>Give your App a name (recommended: keep the APP contact email correspondence to your messenger account).</li>
                <li>Click on the Other option, then click on <strong>Next.</strong></li>
                <li>Select the <strong>Business</strong> option and click on <strong>Next.</strong></li>
                <li>Under Business portfolio:If you already have a business account, select it or,
                </li>
                <li>Click on the <strong>Create App</strong> option.</li>
                <li>Navigate to <strong>Messenger</strong> from the options, click on the <strong>Setup</strong> button.</li>
                <li>Under <strong>Verify token,</strong> copy the token from Anydone and paste it here.</li>
                <li>Click on the <strong>Connect</strong> button under <strong>Generate Access Token</strong>.</li>
                <li>Select the <strong>Facebook page</strong> that you want to integrate.</li>
                <li>Click on <strong>Continue</strong>.</li>
                <li>Click on the <strong>Save</strong> button, then click on the <strong>Got it</strong> button.</li>
                <li>Once you connect your Facebook page, click on <strong>Generate under Generate Access Tokens.</strong></li>
                <li>Copy the access token and paste it under Anydone's <strong>Page Access Token</strong>.</li>
                <li>Once created, the <strong>Callback URL</strong> will be generated by Anydone, so copy it and paste it under Meta's <strong>Callback URL</strong>.</li>
                <li>Click on the <strong>Verify</strong> button, then click on the <strong>Save</strong> button.</li>
                <li>Under Configuration webhooks, subscribe to your preferred option (recommended: subscribe to at least the messages option).</li>
                <li>Under Generate access token, click on the <strong>Add Subscription</strong> button, then select your preferred option (recommended: subscribe to at least the messages option).</li>
                <li>Click on the <strong>Confirm</strong> button.</li>
                <li>Under Generate access token, click on the <strong>Generate button again</strong>.</li>
                <li>Copy the <strong>token</strong>.</li>
                <li>From Anydone, <strong>update</strong> the Page Access Token:
                <li>Click on the three horizontal dots, select the edit option.</li>
                <li>Paste the access token in the Page Access Token field and click on <strong>Update</strong>.</li>
                </li>
            </ol>
        `
    },
    "how-to-integrate-github":{
        title:"How to Integrate GitHub?",
        content:`
        <ol class="steps-list">
            <li>Log to your <strong>GitHub</strong> account</li>
            <li>Click on your profile <strong>icon</strong> in the top right</li>
            <li>Click on the <strong>Settings</strong> option</li>
            <li>Select <strong>Developer settings</strong> from the left menu</li>
            <li>Click on <strong>Personal access tokens</strong> and select <strong>Tokens</strong></li>
            <li>Click on <strong>Generate new token</strong></li>
            <li>Select <strong>Generate new token</strong> from the dropdown menu</li>
            <li>Add a note, define the expiration time for the token, and select the scopes</li>
            <li>Then, click the <strong>Generate Key</strong> button</li>
            <li>Copy the key and paste it into anyone’s <strong>Personal Access Token</strong> placeholder</li>
        </ol>
        `
    },
    "how-to-integrate-whatsapp":{
        title:"How to Integrate WhatsApp?",
        content:`
            <ol class="steps-list">
                <li>Click the "<strong>Login with Facebook</strong>" button.</li>
                <li>Log in to your <strong>Facebook</strong> account.</li>
                <li>Click the "<strong>Get Started</strong>" button.</li>
                <li>Enter the following details:
                    <ol type="a" class="list-left">
                        <li><strong>Business Name</strong></li>
                        <li><strong>Business Email</strong></li>
                        <li><strong>Business Website</strong>: URLs of your Business Account (eg: your business website or your social media pages)</li>
                    </ol>
                </li>
                <li>Select your <strong>Country</strong> from the dropdown menu.</li>
                <li>(Optional) Add your business address.</li>
                <li>Click the "<strong>Next</strong>" button.</li>
                <li>Select a <strong>WhatsApp Business Account</strong> and <strong>Business Profile</strong> from the dropdown menu.</li>
                <li>Click the "<strong>Next</strong>" button.</li>
                <li>Enter the following details:
                    <ol type="a" class="list-left">
                        <li><strong>WhatsApp Business Account Name</strong></li>
                        <li><strong>WhatsApp Business Display Name</strong></li>
                        <li><strong>Business Category</strong> (select from the dropdown)</li>
                    </ol>
                </li>
                <li>Click the "<strong>Next</strong>" button.</li>
                <li>Choose one of the following options:</li>
                <li>"<strong>Get a free WhatsApp number</strong>" (provided by WhatsApp)
                    <ol type="a">
                        <li>"<strong>Add a new number</strong>" (use your own number) (<strong>Note</strong>: Ensure the number you enter is not currently logged in to any device, as per WhatsApp’s policy.)</li>
                    </ol>
                </li>
                <li>Click the "<strong>Next</strong>" button.</li>
                <li>Click the "<strong>Continue</strong>" button.</li>
                <li>Finally, click the "<strong>Finish</strong>" button to complete the integration setup.</li>
            </ol>
        `
    }
}